import React from 'react';
import { TextInput, Button, ToastNotification } from 'carbon-components-react';
import { FormError } from 'components';
import { ArrowRight16 } from '@carbon/icons-react';
import { connect } from 'react-redux';
import { RootState } from 'redux/root.reducer';
import { CFCProps } from 'types';

const RegConfirmationForm: React.FC<Props | any> = (props: any) => {
  const isLoading =
    props.reg?.submitting || props.login?.submitting || props.app?.loading;

  const {
    values,
    touched: fTouched,
    errors: fErrors,
    handleChange,
    handleBlur,
    handleSubmit,
    isSubmitting
  } = props;
  const inputError = ((errors: any, touched: any) => (
    key: 'confirmationCode'
  ) => errors[key] && touched[key] && <FormError>{errors[key]}</FormError>)(
    fErrors,
    fTouched
  );

  return (
    <form onSubmit={handleSubmit}>
      <ToastNotification
        lowContrast
        caption=""
        kind="info"
        iconDescription="describes the close button"
        subtitle={<span>Please check your email for the code.</span>}
        timeout={0}
        title="Registration code confirmation"
      />
      <section className="reg-form-item">
        <TextInput
          id="confirmationCode"
          name="confirmationCode"
          labelText="Confirmation Code"
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.confirmationCode}
          data-testid="confirmationCode"
        />
        {inputError('confirmationCode')}
      </section>
      <section className="reg-form-item">
        <Button
          className="reg-submit"
          type="submit"
          kind={!fErrors ? 'danger' : 'primary'}
          renderIcon={ArrowRight16}
          disabled={isLoading || isSubmitting}
          data-testid="submit"
        >
          {isLoading || isSubmitting ? 'Verifying...' : 'Verify'}
        </Button>
      </section>
    </form>
  );
};

const mapStateToProps = ({ reg, login, app }: RootState) => ({
  reg,
  login,
  app
});

const connector = connect(mapStateToProps);

type Props = CFCProps<typeof connector>;

RegConfirmationForm.displayName = 'RegConfirmationCodeForm';

export default connector(RegConfirmationForm);
